import React, { FC, useEffect, useState } from "react";
import { Row, Col } from "antd";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import { useMediaQuery } from "react-responsive";
import {
  SearchPanel,
  MessagePanel,
  MapPanel,
  HeaderPanel,
} from "components/Dashboard";
import "./Dashboard.scss";
import { useDispatch, useSelector } from "react-redux";
import Autocomplete from "react-google-autocomplete";
import RidePanel from "components/Dashboard/RidePanel";
import { useHistory, useParams, useLocation } from "react-router-dom";
import {
  getPagesRequestPublishTopic,
  getPagesSubscriptionTopic,
  getUserSubscriptionTopic,
  getCreatePageSubscriptionTopic,
  getCreatePagePublishTopic,
  getUpdatePageSubscriptionTopic,
  getProjectsSubscriptionTopic,
  getProjectsRequestPublishTopic,
  getPageFocusSubscriptionTopic,
} from "hooks/MQTTConstants";
import { GET_USERS_LIST } from "reducers/authReducer";
import CallNotification from "containers/Video/CallNotification";
import { generateUUID, popupCenter } from "utils/appUtil";
import VideoPlayerModal from "components/Modals/VideoPlayerModal";
import FirstCADIframeModal from "components/Modals/FirstCADIframeModal";
import { RootState } from "reducers/rootReducer";
import { NetworkClient } from "models/network";
import { SocketTopics, UserTopics } from "../../constants/enums";
import { pushNotification } from "utils/notifications";
import { GET_USER_INFO, GET_USER_AGGREGATE_INFO } from "reducers/authReducer";
import { TOKEN, RID } from "../../constants/localStoreKeys";
import { ENCRYPT_TOKEN } from "reducers/authReducer";

import { getMembersPageListPath } from "../../helpers/request/RequestPath";
import {
  getItemListRequestPayload,
  getPageSearchArgument,
  wrapRequestPayload,
} from "../../helpers/request/RequestPayload";

import useLocalStorageService from "../../services/localStorage";

import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";
// import { onBackgroundMessage } from "firebase/messaging/sw";
import useSocketActions from "../../hooks/socketActions";

// importScripts('https://www.gstatic.com/firebasejs/5.1.0/firebase-app.js');
// importScripts('https://www.gstatic.com/firebasejs/5.1.0/firebase-messaging.js');

const firebaseConfig = {
  apiKey: "AIzaSyBaarBS5TpbG4uMpQTrAqspBVKbwzVkY7k",
  authDomain: "beam-live-passenger.firebaseapp.com",
  databaseURL: "https://beam-live-passenger.firebaseio.com",
  projectId: "beam-live-passenger",
  storageBucket: "beam-live-passenger.appspot.com",
  messagingSenderId: "391484580180",
  appId: "1:391484580180:web:8dca7ed0a3513fa42628c1",
  measurementId: "G-MBQ6J1T667",
};

// const messaging = firebase.messaging();

// messaging.setBackgroundMessageHandler(function (payload) {
//   return self.registration.showNotification(payload.data.title,
//       Object.assign({data: payload.data, requireInteraction: true, tag: 'beam'}));
// });

const useMounted = () => {
  const [isMounted, setIsMounted] = useState(false);
  useEffect(() => {
    setIsMounted(true);
  }, []);
  return isMounted;
};

function formatForRedis(text) {
  return text.replace(/-|_|\./g, function (x) {
    return `\\${x}`;
  });
}

const Dashboard: FC<{ client: NetworkClient; socket: ISocket }> = ({
  client,
  socket,
}) => {
  const {
    searchResult,
    selectedItem,
    callNotification,
    twilioVideoURL,
    searchPage,
    searchArgs,
    friendSearchPage,
    focusItem,
  } = useSelector((state: RootState) => state.search);
  const isMobileScreen = useMediaQuery({ query: "(max-width: 700px)" });
  const [step, setStep] = useState(0);
  const [location, setLocation] = useState<any>();
  const { findUsersToPage, userBds, allUsers } = useSelector(
    (state: RootState) => state.auth
  );
  const { projects, requestIds } = useSelector(
    (state: RootState) => state.dashboard
  );
  const history = useHistory();
  const { search } = useLocation();
  const dispatch = useDispatch();
  const { pageId } = useParams<{ pageId?: string }>();
  const [queryPageId, setQueryPageId] = useState<any>();
  const [callingPageId, setCallingPageId] = useState<string | undefined>(
    undefined
  );
  const [videoPlayerOpen, setVideoPlayerOpen] = useState<boolean>(false);
  const [firstCADVisible, setFirstCADVisible] = useState<boolean>(false);
  const [isCallNotificationDisplayed, setCallNotificaitonDisplayed] =
    useState<boolean>(false);
  const [screens, setScreens] = useState<ScreenStateObj>({
    list: false,
    message: false,
    iframe: false,
    map: false,
    active: "",
    ridePanel: false,
    cadType: "",
  });
  const isMounted = useMounted();
  const { getUserRequestPayload } = useSocketActions();
  const { getLocalStorageItem } = useLocalStorageService();

  const params: DashboardParams = {
    screens,
    setScreens,
    setFirstCADVisible,
  };

  const getCurrentLocation = () => {
    return new Promise((resolve, reject) => {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition((position) => {
          setLocation({
            lat: position?.coords?.latitude,
            long: position?.coords?.longitude,
          });
        });
      } else {
        reject("Geolocation is not supported by this browser.");
      }
    });
  };

  useEffect(() => {
    if (twilioVideoURL) {
      setVideoPlayerOpen(true);
    }
  }, [twilioVideoURL]);

  const handleChangeStep = (sType: string) => {
    if (sType === "next" && step < 2) setStep(step + 1);
    if (sType === "before" && step > 0) setStep(step - 1);
  };

  const createFriendPage = (friendUserId) => {
    const user = allUsers?.find(
      (obj) => obj.id === localStorage.getItem("RID")
    );
    const friendUser = allUsers?.find((obj) => obj.id === friendUserId);
    const timestamp = Date.now();
    var changes = [];
    changes.push({
      op: "add",
      path: "/persistent/static/metadata/createdAt",
      value: timestamp,
    });
    changes.push({
      op: "add",
      path: "/persistent/dynamic/metadata/updatedAt",
      value: timestamp,
    });
    changes.push({
      op: "add",
      path: "/persistent/static/metadata/type",
      value: "friend",
    });
    changes.push({
      op: "add",
      path: `/persistent/static/metadata/members/users/${localStorage.getItem(
        "RID"
      )}`,
      value: {
        beamId: user?.beamId || `User#${localStorage.getItem("RID")}`,
        role: "write",
      },
    });
    changes.push({
      op: "add",
      path: `/persistent/static/metadata/members/users/${friendUserId}`,
      value: {
        beamId: friendUser?.beamId || `User#${friendUserId}`,
        role: "write",
      },
    });

    socket.publishToEvent(
      SocketTopics.PublishPageTopics,
      getCreatePagePublishTopic(),
      wrapRequestPayload({ changes }),
      (data) => {
        if (!data.status) {
          console.log("Publish error: ", data.message);
        }
      }
    );
  };

  useEffect(() => {
    if (friendSearchPage) {
      if (friendSearchPage.pages.length === 0) {
        createFriendPage(friendSearchPage.friendUserId);
      } else {
        dispatch({
          type: "SELECT_FRIEND_PAGE",
          payload: friendSearchPage.pages?.[0],
        });
      }
    }
  }, [friendSearchPage]);

  useEffect(() => {
    dispatch(GET_USERS_LIST());
    if (!getLocalStorageItem(TOKEN)) {
      history.push("/auth/login");
    }
    getCurrentLocation();
    const query = new URLSearchParams(search);
    setQueryPageId(query.get('id'));

  }, []);

  const setSelectedPage = (item: SelectedSearchItem | undefined) => {
    setScreens({
      ...screens,
      map: true,
      message: true,
      rxPanel: false,
      ridePanel: false,
      active: "",
    });
    dispatch({ type: "SET_SELECTED_ITEM", payload: item });
  };

  useEffect(() => {
    if ((pageId || queryPageId) && searchResult && searchResult.length > 0) {
      const page = searchResult.find(
        (item) => item.pageId.toString() === pageId || item.pageId.toString() === queryPageId
      );
      setSelectedPage(page);
    }
  }, [pageId, searchResult, queryPageId]);

  useEffect(() => {
    if (selectedItem?.pageId) {
      setScreens({
        ...screens,
        map: true,
        message: true,
        ridePanel: false,
        active: "",
      });
    }
  }, [selectedItem]);

  const searchPageQuery = (offset = 0, limit = 10, searchArgs = undefined) => {
    // let paths = [];
    // const filter = JSON.parse(localStorage.getItem("filter"));
    // if (filter) {
    //   const { owner, liveIoT, pageStatus } = filter;
    //   if (liveIoT.indexOf("GPS") !== -1) {
    //     paths.push(
    //       "$.nonpersistent.static.live.connections..activeIot..iotUdid"
    //     );
    //   }
    //   if (liveIoT.indexOf("Video") !== -1) {
    //     paths.push("$.nonpersistent.dynamic.live.activeCall.roomId");
    //   }
    //   if (pageStatus) {
    //     paths.push(
    //       `$..status[?(@property == 'name' && @.match(/.*${pageStatus}/i))]`
    //     );
    //   }
    //   if (owner && owner !== "") {
    //     paths = [
    //       `$.persistent.static.metadata.members.users.${owner}[?(@property == 'role' && @.match(/.*edit/i))]`,
    //     ];
    //   }
    // }

    console.log("search args", searchArgs);

    const searchArguments = getPageSearchArgument(
      searchArgs?.search,
      searchArgs?.args
    );
    const {
      load,
      searchIndex,
      searchQuery,
      sortByProperties,
      filterExpression,
    } = searchArguments;
    console.log("searchArguments", searchArguments);


    const requestId = generateUUID();
    localStorage.setItem("pageRequestId", requestId);

    const pageRequest = {
      select: {
        index: {
          // searchIndex: `${process.env.REACT_APP_ECO_SYSTEM}:pageUpdatedAtIndex`,
          // searchQuery: `@pageMembers:{${localStorage.getItem(
          //   "RID"
          // )}}@objectStatus:{active}`,
          searchIndex,
          searchQuery,
          searchOptions: "TIMEOUT 10000",
        },
        list:
          (pageId || queryPageId)
            ? { objectIds: [pageId || queryPageId] }
            : {},
        // load: {
        //   persistent: "$.persistent",
        //   nonpersistent: "$.nonpersistent",
        //   pageId: "$.objectId",
        //   title: "$.persistent.static.metadata.title",
        //   updatedAt: "$..lastSent.members.updatedAt",
        // },
        load,
      },
      apply: {
        expression: "",
        name: "",
      },
      result: {
        pagination: {
          offset,
          limit,
        },
      },
      sortBy: {
        // properties: [
        //   {
        //     field: "@updatedAt",
        //     order: "DESC",
        //   },
        // ],
        // max: 10000,
        properties: sortByProperties,
        max: offset + limit,
      },
      filter: {
        // expression: (searchArgs?.search && searchArgs?.search !== "") ? `exists(@title) && contains(@title, '${searchArgs?.search}')`: ``,
        expression: filterExpression,
      },
      anyStatus: false,
    };

    console.log("page request", pageRequest);
    socket.publishToEvent(
      SocketTopics.PublishPageTopics,
      `${process.env.REACT_APP_ECO_SYSTEM}/connection/${localStorage.getItem(
        "CID"
      )}/service/bds/aggregateBds`,
      wrapRequestPayload(pageRequest, requestIds.page)
    );
  };

  const aggregateUser = (inputQueryId: string, filterText?: string) => {
    const requestId = generateUUID();
    localStorage.setItem("userRequestId", requestId);
    socket.publishToEvent(
      SocketTopics.PublishPageTopics,
      `${process.env.REACT_APP_ECO_SYSTEM}/connection/${localStorage.getItem(
        "CID"
      )}/service/bds/aggregateBds`,
      wrapRequestPayload(
        {
          select: {
            index: {
              searchIndex: `${process.env.REACT_APP_ECO_SYSTEM}:userNameIndex`,
              searchQuery: "*",
              searchOptions: "TIMEOUT 10000",
            },
            list: {
              inputQueryId: inputQueryId,
            },
            load: {
              objectId: "$.objectId",
              liveObject: "$.persistent.static",
              status: "$.nonpersistent.static.live.status",
            },
          },
          groupBy: {
            properties: ["@objectId"],
            reducers: [
              {
                func: "TOLIST",
                arguments: ["@liveObject"],
                name: "profile",
              },
            ],
          },
          apply: {
            expression: "",
            name: "",
          },
          filter: {
            expression: "",
          },
          result: {
            pagination: {
              offset: 0,
              limit: 10000,
            },
          },
          anyStatus: false,
        },
        requestIds.user
      )
    );
  };

  useEffect(() => {
    if (findUsersToPage) {
      aggregateUser(findUsersToPage.queryId);
    }
  }, [findUsersToPage]);

  const findUsers = (serviceId) => {
    const queryId = generateUUID();
    socket.publishToEvent(
      SocketTopics.PublishPageTopics,
      `${process.env.REACT_APP_ECO_SYSTEM}/connection/${localStorage.getItem(
        "CID"
      )}/service/live/findUsersToPage`,
      wrapRequestPayload(
        {
          userId: localStorage.getItem("RID"),
          cudbServiceId: serviceId,
          // modes: [...Object.assign([], serviceId.length > 0 ? ['cudb']: [])],
          modes: ["liveMember", "allNotLiveCudb"],
          // modes: ["liveMember", "liveFriend", ...Object.assign([], serviceId.length > 0 ? ['cudb']: [])],
        },
        queryId
      )
    );
  };

  useEffect(() => {
    if (projects) {
      findUsers([projects?.userServiceId]);
      let serviceId = "cudb-live";
      projects?.serviceIds?.map((id) => {
        if (id?.[0] !== "cudb-live" && id?.[0] !== "cudb-root") {
          serviceId = id?.[0];
        }
      });
      dispatch(GET_USER_AGGREGATE_INFO({ serviceId }));
    }
  }, [projects]);

  const getPermission = async (messaging) => {
    return new Promise((resolve, reject) => {
      Notification.requestPermission().then((permission) => {
        if (permission === "granted") {
          resolve(true);
        } else {
          pushNotification(
            "You have blocked notifications in your browser. Please enable it in settings",
            "error",
            "TOP_CENTER",
            2000
          );
          resolve(false);
        }
      });
    });
  };

  const handleNotification = (payload) => {
    const { title, body, icon } = payload.notification;
    browserNotifyIfInactive(title, body, icon);
  };

  const browserNotifyIfInactive = (title, body, icon, page = null) => {
    const notification = new Notification(title, {
      body,
      icon,
      requireInteraction: true,
      tag: "beam",
    });
    notification.addEventListener("click", () => {
      window.focus();
      notification.close();
    });
  };

  useEffect(() => {
    if (socket.client) {
      socket.subscribeToEvent(
        SocketTopics.SubscribePageTopics,
        getPagesSubscriptionTopic()
      );
      socket.subscribeToEvent(
        SocketTopics.SubscribePageTopics,
        getUserSubscriptionTopic()
      );
      socket.subscribeToEvent(
        SocketTopics.SubscribePageTopics,
        getPageFocusSubscriptionTopic()
      );
      socket.subscribeToEvent(
        SocketTopics.SubscribePageTopics,
        getCreatePageSubscriptionTopic()
      );

      socket.subscribeToEvent(
        SocketTopics.SubscribePageTopics,
        getUpdatePageSubscriptionTopic()
      );

      socket.subscribeToEvent(
        SocketTopics.SubscribePageTopics,
        getProjectsSubscriptionTopic()
      );

      socket.publishToEvent(
        SocketTopics.PublishPageTopics,
        getProjectsRequestPublishTopic(),
        wrapRequestPayload({
          userId: localStorage.getItem("RID"),
        })
      );

      socket.subscribeToEvent(
        SocketTopics.SubscribePageTopics,
        `${process.env.REACT_APP_ECO_SYSTEM}/connection/${localStorage.getItem(
          "CID"
        )}/service/iot-service/getLastIndex/reply`
      );

      // socket.publishToEvent(
      //   SocketTopics.PublishPageTopics,
      //   `${process.env.REACT_APP_ECO_SYSTEM}/connection/${localStorage.getItem(
      //     "CID"
      //   )}/service/iot-service/getLastIndex`,
      //   wrapRequestPayload({
      //     "filter": "ecosystem=beamdev userId=1492 channelName=locationGps",
      //     "options": {
      //       "latest": false
      //     }
      //   }, '1492')
      // );

      searchPageQuery();
      // findUsers();
      // getUserBds();

      socket.subscribeToEvent(
        SocketTopics.SubscribePageTopics,
        `${process.env.REACT_APP_ECO_SYSTEM}/connection/${localStorage.getItem(
          "CID"
        )}/service/live/findUsersToPage/reply`
      );

      // iot testing
      socket.subscribeToEvent(
        SocketTopics.SubscribePageTopics,
        `${process.env.REACT_APP_ECO_SYSTEM}/connection/20036/service/iot-service/append`
      );

      socket.subscribeToEvent(
        SocketTopics.SubscribePageTopics,
        `${process.env.REACT_APP_ECO_SYSTEM}/connection/${localStorage.getItem(
          "CID"
        )}/service/bds/searchBds/reply`
      );

      socket.subscribeToEvent(
        SocketTopics.SubscribePageTopics,
        `${process.env.REACT_APP_ECO_SYSTEM}/connection/${localStorage.getItem(
          "CID"
        )}/service/bds/aggregateBds/reply`
      );

      const app = initializeApp(firebaseConfig);
      const messaging: any = getMessaging(app);

      setTimeout(async () => {
        if (await getPermission(messaging)) {
          getToken(messaging, {})
            .then((currentToken) => {
              if (currentToken) {
                let changes = [
                  {
                    op: "add",
                    path: `/nonpersistent/static/live/fcmToken`,
                    value: {
                      token: currentToken,
                      deviceType: "web",
                      deviceName: "web",
                      userId: localStorage.getItem("RID"),
                    },
                  },
                ];
                socket.publishToEvent(
                  SocketTopics.PublishPageTopics,
                  `${
                    process.env.REACT_APP_ECO_SYSTEM
                  }/connection/${localStorage.getItem(
                    "CID"
                  )}/service/cudb-live/updateDevice`,
                  wrapRequestPayload({
                    // objectId: localStorage.getItem('RID'),
                    alternativeIds: [
                      {
                        udid: localStorage.getItem("UUID"),
                      },
                    ],
                    changes,
                  })
                );
                // ...
              } else {
                // Show permission request UI
                console.log(
                  "No registration token available. Request permission to generate one."
                );
                // ...
              }
            })
            .catch((err) => {
              console.log("An error occurred while retrieving token. ", err);
              // ...
            });

          onMessage(messaging, (payload) => {
            handleNotification(payload);
          });
        }
      });
    }
  }, [socket.client]);

  useEffect(() => {
    if (searchArgs && isMounted) {
      searchPageQuery(searchPage.offset, searchPage.limit, searchArgs);
    }
  }, [searchArgs]);

  useEffect(() => {}, [socket.client]);

  useEffect(() => {
    if (focusItem) {
      // console.log('focus item', focusItem);
      setStep(1);
      dispatch({ type: "SET_SELECTED_ITEM", payload: focusItem });
      dispatch({
        type: "SET_MESSAGE_FILTER",
        payload: [],
      });
    }
  }, [focusItem]);

  useEffect(() => {
    setCallNotificaitonDisplayed(!!callNotification);
    if (callNotification) {
      setCallingPageId(callNotification?.page?.id);
    } else {
      setCallingPageId(undefined);
    }
  }, [callNotification]);

  const getFriendUser = (members) => {
    const userIndex = Object.keys(members).find((x) => {
      return x !== localStorage.getItem("RID");
    });
    const user = allUsers?.find((obj) => obj.id === userIndex);
    return {
      profileImage: user?.profileImage?.urls?.original?.url,
      beamId: user?.beamId,
    };
  };

  const handleCallAccept = (page: any) => {
    // popupCenter(
    //   window.location.origin + `/video/${page.id || page.videoRoomId}`,
    //   "beamLive Video Call",
    //   800,
    //   600
    // );
    // setCallNotificaitonDisplayed(false);
    const user = allUsers?.find((obj) => obj.id === localStorage.getItem('RID'));
    dispatch(
      ENCRYPT_TOKEN({
        data: {
          payload: JSON.stringify({
            userId: localStorage.getItem("RID"),
            userBeamId: user?.beamId,
            connectionId: `${localStorage.getItem("CID")}`,
            pageId: page.id || page.videoRoomId,
            pageTitle: page?.page?.persistent?.static?.metadata?.title ||
            (page?.page?.persistent?.static?.metadata?.type === "friend" &&
            getFriendUser(page?.page?.persistent?.static?.metadata?.members?.users)
              ?.beamId
              ? getFriendUser(
                page?.page?.persistent?.static?.metadata?.members?.users
                )?.beamId
              : `Page ${page?.pageId}`),
          }),
        },
        callback: (token) => {
          setCallNotificaitonDisplayed(false);
          // console.log("encrrypted token here", token);
          window.open(`${process.env.REACT_APP_VIDEO_URI}/room/${token.encryptedPayload}`, '_blank');
          // console.log('url here', `${process.env.REACT_APP_ADMIN_API}?token=${token.encryptedPayload}`)
        },
      })
    );


  };

  const handleCallDecline = () => {
    setCallNotificaitonDisplayed(false);
  };

  const fixedColSize = (pageId || queryPageId) ? 12 : 8;

  return (
    <Row className="main-layout">
      {isCallNotificationDisplayed && (
        <CallNotification
          page={callNotification?.page}
          sender={callNotification?.sender}
          onAccept={handleCallAccept}
          onDecline={handleCallDecline}
          allUsers={allUsers}
        />
      )}
      <div className="step-navigator">
        {step > 0 ? (
          <LeftOutlined onClick={() => handleChangeStep("before")} />
        ) : (
          <div></div>
        )}
        {step < 2 ? (
          <RightOutlined onClick={() => handleChangeStep("next")} />
        ) : (
          <div></div>
        )}
      </div>

      {(((isMobileScreen || screens.iframe) &&
        (step == 0 || step === 1 || step === 2)) ||
        (!isMobileScreen && !screens.iframe)) &&
        (!pageId && !queryPageId) && (
          <Col
            md={8}
            xs={24}
            className={screens.iframe ? "iframe-main-layout" : ""}
          >
            <HeaderPanel socket={socket} />

            {screens.iframe && (
              <div className="iframe-navigator">
                {step > 0 ? (
                  <span onClick={() => handleChangeStep("before")}>
                    <LeftOutlined />{" "}
                    {step === 1 ? " Pages" : step === 2 ? " Chat" : ""}
                  </span>
                ) : (
                  <div></div>
                )}
                {step < 2 ? (
                  <span onClick={() => handleChangeStep("next")}>
                    {step === 0 ? "Chat " : step === 1 ? "Map " : ""}{" "}
                    <RightOutlined />
                  </span>
                ) : (
                  <div></div>
                )}
              </div>
            )}

            {step === 0 && (
              <SearchPanel
                callingPageId={callingPageId}
                socket={socket}
                params={params}
              />
            )}

            {step === 1 && <MessagePanel socket={socket} params={params} />}

            {step === 2 && <MapPanel socket={socket} params={params} />}

            <div className="footer-panel mr-4">
              <p>© All rights reserved beam</p>
            </div>
          </Col>
        )}

      {!screens.iframe ? (
        <React.Fragment>
          {((isMobileScreen && step == 1) || !isMobileScreen) &&
            (screens.message || screens.ridePanel) && (
              <Col
                md={screens.map ? fixedColSize : 16}
                xs={24}
                className={
                  screens.active === "message" ||
                  screens.active === "rideDispatch" ||
                  screens.active === "rxPanel"
                    ? "active-screen"
                    : ""
                }
              >
                {screens.message && (
                  <MessagePanel socket={socket} params={params} />
                )}
                {screens.ridePanel && (
                  <RidePanel type={screens.cadType} params={params} />
                )}
              </Col>
            )}
          {((isMobileScreen && step == 2) || !isMobileScreen) && screens.map && (
            <Col
              md={screens.message || screens.ridePanel ? fixedColSize : 16}
              xs={24}
              className={screens.active === "map" ? "active-screen" : ""}
            >
              <MapPanel socket={socket} params={params} />
            </Col>
          )}
        </React.Fragment>
      ) : (
        <Col
          md={16}
          className={`iframe-container ${
            screens?.iframeUrl?.includes("dashboard") ? "dashboard" : "cad"
          }`}
        >
          <iframe
            src={`${screens?.iframeUrl}&lat=${location?.lat}&lng=${location?.long}`}
            title="Shared"
          ></iframe>
        </Col>
      )}

      <Autocomplete
        apiKey="AIzaSyDNIyoSDV1wnJVW8wdHkiNG-eZ2bMcq0iY"
        style={{ display: "none" }}
        options={{
          types: ["(regions)"],
          componentRestrictions: { country: ["us", "ca", "uk"] },
        }}
      />
      {videoPlayerOpen && (
        <VideoPlayerModal
          url={twilioVideoURL}
          onClose={() => setVideoPlayerOpen(false)}
        />
      )}
      <FirstCADIframeModal
        isModalVisible={firstCADVisible}
        onClose={() => {
          setFirstCADVisible(false);
        }}
      />
    </Row>
  );
};

export default Dashboard;
